let keyMirror = require("keymirror");

module.exports = keyMirror({
  STATIC_CACHE_VERSIONS_WILL_GET: null,
  STATIC_CACHE_VERSIONS_DID_GET: null,
});
